export default __webpack_public_path__ + "static/media/aboutSalon.b37dfeba.jpg";